<template>
    <div>
        <v-text-field
            v-if="element.tag === 'v-text-field'"
            :class="{ required: element.isRequired }"
            :label="element.label"
            :required="element.isRequired"
            :value="value"
            dense
            outlined
            v-bind="$attrs"
            @change="triggerChange"
            v-on="$listeners"
        ></v-text-field>
        <v-menu
            v-if="element.tag === 'v-date-picker'"
            v-model="datePickerOpen"
            :close-on-content-click="false"
            min-width="290px"
            offset-y
            transition="scale-transition"
        >
            <template #activator="{ on }">
                <v-text-field
                    v-model="itemModel"
                    :class="{ required: element.isRequired }"
                    :label="element.label"
                    dense
                    outlined
                    readonly
                    v-bind="$attrs"
                    @change="triggerChange"
                    v-on="on"
                ></v-text-field>
            </template>
            <v-date-picker
                v-model="itemModel"
                v-bind="$attrs"
                @input="datePickerOpen = false"
                v-on="$listeners"
            ></v-date-picker>
        </v-menu>
        <b-static-input
            v-if="element.tag === 'static-input'"
            :label="element.label"
            :value="value || element.value"
        ></b-static-input>
    </div>
</template>

<script>
export default {
    name: 'DynamicComponent',
    props: {
        element: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            datePickerOpen: false,
            itemModel: this.value,
        };
    },
    methods: {
        triggerChange(val) {
            this.$emit('change', val);
        },
    },
};
</script>
